import { useState, useEffect } from "react"

export default function useMousePosition() {
  let [MousePosition, setMousePosition] = useState({ x: null, y: null })


    
  return MousePosition
}
